import { forwardRef } from "react";
import { useValidation } from "@/shared/forms";
import type { StringField as StringFieldProps } from "./types";

export const StringField = forwardRef<HTMLInputElement, StringFieldProps>(function StringField(
    { ariaLabel, value, onChange, required, placeholder, id, ...rest },
    ref,
) {
    useValidation(id, {
        errorLocation: "callout",
        rules: { required },
    });
    return (
        <input
            id={id}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            required={required}
            aria-label={ariaLabel}
            placeholder={placeholder}
            ref={ref}
            {...rest}
        />
    );
});
